"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LedgerAccountGroup = exports.TransactionType = exports.ExpenseAccounts = exports.CurrentLiabilityAccounts = exports.LongTermLiabilityAccounts = exports.EquityAccounts = exports.CurrentAssetAccounts = exports.AccountSubCategories = exports.AccountCategories = void 0;
/**
 * Account definitions
 *
 * Fundamental equation:
 * Assets = Liabilities + Equity
 */
// Unused, but keeping definition
var AccountCategories;
(function (AccountCategories) {
    AccountCategories["Liability"] = "liability";
    AccountCategories["Asset"] = "asset";
    AccountCategories["Equity"] = "equity";
})(AccountCategories = exports.AccountCategories || (exports.AccountCategories = {}));
// Unused, but keeping definition
var AccountSubCategories;
(function (AccountSubCategories) {
    AccountSubCategories["CurrentLiability"] = "shortTermLiability";
    AccountSubCategories["LongTermLiability"] = "longTermLiability";
})(AccountSubCategories = exports.AccountSubCategories || (exports.AccountSubCategories = {}));
var CurrentAssetAccounts;
(function (CurrentAssetAccounts) {
    CurrentAssetAccounts["Cash"] = "cash";
})(CurrentAssetAccounts = exports.CurrentAssetAccounts || (exports.CurrentAssetAccounts = {}));
var EquityAccounts;
(function (EquityAccounts) {
    EquityAccounts["ShareholdersEquity"] = "shareholdersEquity";
})(EquityAccounts = exports.EquityAccounts || (exports.EquityAccounts = {}));
var LongTermLiabilityAccounts;
(function (LongTermLiabilityAccounts) {
    LongTermLiabilityAccounts["LongTermDebt"] = "longTermDebt";
})(LongTermLiabilityAccounts = exports.LongTermLiabilityAccounts || (exports.LongTermLiabilityAccounts = {}));
var CurrentLiabilityAccounts;
(function (CurrentLiabilityAccounts) {
    CurrentLiabilityAccounts["AccruedAccountBankFee"] = "accruedAccountBankFee";
    CurrentLiabilityAccounts["AccruedAdminFee"] = "accruedAdminFee";
    CurrentLiabilityAccounts["AccruedBackupServicingFee"] = "accruedBackupServicingFee";
    CurrentLiabilityAccounts["AccruedCollateralAgentFee"] = "accruedCollateralAgentFee";
    CurrentLiabilityAccounts["AccruedCollateralManagementFee"] = "accruedCollateralManagementFee";
    CurrentLiabilityAccounts["AccruedCollectionAccountFee"] = "accruedCollectionAccountFee";
    CurrentLiabilityAccounts["AccruedCommitmentFee"] = "accruedCommitmentFee";
    CurrentLiabilityAccounts["AccruedCustodianFee"] = "accruedCustodianFee";
    CurrentLiabilityAccounts["AccruedDrawFee"] = "accruedDrawFee";
    CurrentLiabilityAccounts["AccruedInterest"] = "accruedInterest";
    CurrentLiabilityAccounts["AccruedOriginationFee"] = "accruedOriginationFee";
    CurrentLiabilityAccounts["AccruedOtherFee"] = "accruedOtherFee";
    CurrentLiabilityAccounts["AccruedPayingAgentFee"] = "accruedPayingAgentFee";
    CurrentLiabilityAccounts["AccruedServicingFee"] = "accruedServicingFee";
    CurrentLiabilityAccounts["AccruedTrustAccountFee"] = "accruedTrustAccountFee";
    CurrentLiabilityAccounts["AccruedUnusedInterest"] = "accruedUnusedInterest";
    CurrentLiabilityAccounts["AccruedUtilizationAdditionalInterest"] = "accruedUtilizationAdditionalInterest";
    CurrentLiabilityAccounts["AccruedVerificationAgentFee"] = "accruedVerificationAgentFee";
})(CurrentLiabilityAccounts = exports.CurrentLiabilityAccounts || (exports.CurrentLiabilityAccounts = {}));
var ExpenseAccounts;
(function (ExpenseAccounts) {
    ExpenseAccounts["AccountBankFeeExpense"] = "accountBankFeeExpense";
    ExpenseAccounts["AdminFeeExpense"] = "adminFeeExpense";
    ExpenseAccounts["BackupServicingFeeExpense"] = "backupServicingFeeExpense";
    ExpenseAccounts["CollateralAgentFeeExpense"] = "collateralAgentFeeExpense";
    ExpenseAccounts["CollateralManagementFeeExpense"] = "collateralManagementFeeExpense";
    ExpenseAccounts["CollectionAccountFeeExpense"] = "collectionAccountFeeExpense";
    ExpenseAccounts["CommitmentFeeExpense"] = "commitmentFeeExpense";
    ExpenseAccounts["CustodianFeeExpense"] = "custodianFeeExpense";
    ExpenseAccounts["DrawFeeExpense"] = "drawFeeExpense";
    ExpenseAccounts["InterestExpense"] = "interestExpense";
    ExpenseAccounts["OriginationFeeExpense"] = "originationFeeExpense";
    ExpenseAccounts["OtherFeeExpense"] = "otherFeeExpense";
    ExpenseAccounts["PayingAgentFeeExpense"] = "payingAgentFeeExpense";
    ExpenseAccounts["ServicingFeeExpense"] = "servicingFeeExpense";
    ExpenseAccounts["TrustAccountFeeExpense"] = "trustAccountFeeExpense";
    ExpenseAccounts["UnusedInterestExpense"] = "unusedInterestExpense";
    ExpenseAccounts["UtilizationAdditionalInterestExpense"] = "utilizationAdditionalInterestExpense";
    ExpenseAccounts["VerificationAgentFeeExpense"] = "verificationAgentFeeExpense";
})(ExpenseAccounts = exports.ExpenseAccounts || (exports.ExpenseAccounts = {}));
/**
 * Transactions and entries
 */
var TransactionType;
(function (TransactionType) {
    TransactionType["CollectionsRecycle"] = "collectionsRecycle";
    TransactionType["CollectionsPaydown"] = "collectionsPaydown";
    TransactionType["CurePaydown"] = "curePaydown";
    TransactionType["DailyAccrual"] = "dailyAccrual";
    TransactionType["DecreaseCurrentLiability"] = "decreaseCurrentLiability";
    TransactionType["DecreaseExpensePayment"] = "decreaseExpensePayment";
    TransactionType["DecreaseOutstandingLoanBalance"] = "decreaseOutstandingLoanBalance";
    TransactionType["DrawRequest"] = "drawRequest";
    TransactionType["ExpensePayment"] = "expensePayment";
    TransactionType["IncreaseCurrentLiability"] = "increaseCurrentLiability";
    TransactionType["IncreaseExpensePayment"] = "increaseExpensePayment";
    TransactionType["IncreaseOutstandingLoanBalance"] = "increaseOutstandingLoanBalance";
    TransactionType["ReconciliationAdjustment"] = "reconciliationAdjustment";
    TransactionType["ZeroCurrentLiabilities"] = "zeroCurrentLiabilities";
})(TransactionType = exports.TransactionType || (exports.TransactionType = {}));
var LedgerAccountGroup;
(function (LedgerAccountGroup) {
    LedgerAccountGroup["OutstandingLedger"] = "outstandingLedger";
    LedgerAccountGroup["ExpensesFees"] = "expensesFees";
})(LedgerAccountGroup = exports.LedgerAccountGroup || (exports.LedgerAccountGroup = {}));
//# sourceMappingURL=Accounting.js.map